module.exports = __webpack_public_path__ + "img/nln1-b1.f09da9f2.gif";